import gql from 'graphql-tag'
import UserFragment from '../fragments/UserFragment';

export default gql`
mutation setPassword($input: SetPasswordInput!) {
  setPassword(input: $input) {
    token
    user {
      ...UserFragment
    }
  }
}
${UserFragment}
`
